import {Button, Col,  Form, Input, message, Row, theme} from "antd";
import {setAuthToken} from "../../../service/auth/axios";
import {useDispatch, useSelector} from "react-redux";
import {authData} from "../../../store/slice/authSlice";
import apiService from "../../../service/apis/api";
import './index.scss'
import {useNavigate} from "react-router-dom";
import {useCallback} from "react";
import {BsMoon} from "react-icons/bs";
import {SunOutlined} from "@ant-design/icons";
import {changeThemeMode} from "../../../store/slice/themeSlice";
import BackgroundContent from "../../../AppLayout/AppPage/BackgrountContent";
const Login = () => {
    const {data:{isLoading }}=useSelector(state => state.auth)
    const dispatch = useDispatch()
    const navigate=useNavigate()
    const {systemMode}=useSelector(state => state.theme)
    const isDarkHandle=()=>{
        dispatch(changeThemeMode())
    }
    const {
        token: {mainBg },
    } = theme.useToken();

    const onFinish = useCallback(async (values) => {
        dispatch(authData({
            user: null,
            isLoading: true,
            isAuthenticated: false,
        }));
        if (localStorage.getItem('token')) {
            localStorage.removeItem('refToken');
        }
        try {
            const data = await apiService.postData('/login/', values);
            localStorage.setItem('token', data?.token);
            setAuthToken(data.token);
            dispatch(authData({
                user: {role:"admin" , name:"o'quvchi"},
                isLoading: false,
                isAuthenticated: true,
            }));
            navigate('/');
            message.success('Успешно');
        } catch (error) {
            message.error(error?.response?.data?.detail);
            dispatch(authData({
                user: null,
                isLoading: false,
                isAuthenticated: false,
            }));
        }
        dispatch(authData({
                    user: {role:"admin" , name:"o'quvchi"},
                    isLoading: false,
                    isAuthenticated: true,
                }));
    }, [dispatch, navigate]);

    return (
        <div
            style={{
                background: mainBg,
                overflow:"hidden",
            }}
            className={'login--page'}  >
            {<BackgroundContent>
                        <div className={'login-card'}>

                                    <img
                                        src={'/Logo_.png'}
                                        alt="logo"
                                        className={'login-logo'}
                                        style={{objectFit: "contain", background: "#fff30"}}
                                    />

                            <Form
                                name="basic"
                                labelCol={{
                                    span: 24,
                                }}
                                wrapperCol={{
                                    span: 24,
                                }}
                                style={{
                                    maxWidth: 600,
                                    width: '100%',
                                }}
                                initialValues={{
                                    uuid: ''
                                }}
                                onFinish={onFinish}
                                autoComplete="off"
                            >
                                <Form.Item
                                    label="Введите идентификатор:"
                                    name="uuid"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Введите идентификатор!',
                                        },
                                    ]}
                                >
                                    <Input placeholder={'Введите идентификатор:'}/>
                                </Form.Item>

                                <Form.Item
                                    wrapperCol={{
                                        span: 24,
                                    }}
                                >
                                    <Row gutter={10} justify={'center'}>
                                        <Col span={20}>
                                            <Button type="primary" htmlType="submit" style={{width:'100%'}} disabled={isLoading}>
                                                Вход
                                            </Button>
                                        </Col>
                                        <Col span={4}>
                                            <Button onClick={isDarkHandle} type="primary">
                                                {
                                                    systemMode==='light'?
                                                        <BsMoon className={'icon'} style={{fontSize:18}} />:
                                                        <SunOutlined className={'icon'} style={{fontSize:18}}/>
                                                }
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form.Item>
                            </Form>
                        </div>
                </BackgroundContent>
            }
        </div>

    );
};

export default Login;